import axios from "axios";

const BASE_URL = process.env.REACT_APP_ORDERS_SERVICE_BASE_URL;

export interface OfferType {
  _id: string;
  name: string;
  partner_percentage: number; // Percentage of teracar commission
  description?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateOfferTypeDto {
  name: string;
  partner_percentage: number; // Percentage of teracar commission
  description?: string;
  is_active?: boolean;
}

export interface UpdateOfferTypeDto {
  name?: string;
  partner_percentage?: number; // Percentage of teracar commission
  description?: string;
  is_active?: boolean;
}

export interface OfferTypesResponse {
  status: string | boolean;
  data: {
    offer_types: OfferType[];
    pagination: {
      total: number;
      page: number;
      limit: number;
      total_pages: number;
    };
  };
}

export interface ActiveOfferTypesResponse {
  status: string | boolean;
  data: {
    offer_types: OfferType[];
  };
}

export const offerTypeService = {
  getOfferTypes: async (page: number = 1, limit: number = 100, is_active?: boolean): Promise<OfferTypesResponse> => {
    const token = localStorage.getItem("token");
    const params: any = { page, limit };
    if (is_active !== undefined) {
      params.is_active = is_active;
    }
    const { data } = await axios.get<OfferTypesResponse>(
      `${BASE_URL}/api/v1/offer-types`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params,
      }
    );
    return data;
  },

  getActiveOfferTypes: async (): Promise<ActiveOfferTypesResponse> => {
    const token = localStorage.getItem("token");
    const { data } = await axios.get<ActiveOfferTypesResponse>(
      `${BASE_URL}/api/v1/offer-types/active`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return data;
  },

  getOfferTypeById: async (offerTypeId: string): Promise<OfferType> => {
    const token = localStorage.getItem("token");
    const { data } = await axios.get<{ status: string; data: OfferType }>(
      `${BASE_URL}/api/v1/offer-types/${offerTypeId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return data.data;
  },

  createOfferType: async (offerTypeData: CreateOfferTypeDto): Promise<OfferType> => {
    const token = localStorage.getItem("token");
    const { data } = await axios.post<{ status: string; data: OfferType }>(
      `${BASE_URL}/api/v1/offer-types`,
      offerTypeData,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return data.data;
  },

  updateOfferType: async (offerTypeId: string, offerTypeData: UpdateOfferTypeDto): Promise<OfferType> => {
    const token = localStorage.getItem("token");
    const { data } = await axios.put<{ status: string; data: OfferType }>(
      `${BASE_URL}/api/v1/offer-types/${offerTypeId}`,
      offerTypeData,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return data.data;
  },

  deleteOfferType: async (offerTypeId: string): Promise<void> => {
    const token = localStorage.getItem("token");
    await axios.delete(`${BASE_URL}/api/v1/offer-types/${offerTypeId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};

